import {
  DAYS_TO_RECORD_DRUG_SCREEN,
  MINUTES_TO_RECORD_DRUG_SCREEN_WITHOUT_MODAL,
  SUPPORTED_APPOINTMENT_TYPES_FOR_AD_HOC_DRUG_SCREEN
} from '@/constants/drugScreen';
import type { Appointment } from '@/types/appointments';

import { daysBetween, minutesBetween } from './dates';

export const getDrugScreenTimeWindowsData = (appointment?: Appointment) => {
  const now = new Date();

  const startAt = appointment?.start_at ? new Date(appointment?.start_at) : new Date();
  const endAt = appointment?.end_at ? new Date(appointment?.end_at) : new Date();
  const durationInMinutes =
    appointment?.start_at && appointment?.end_at
      ? (endAt.getTime() - startAt.getTime()) / 60000
      : 0;

  const isOngoing =
    appointment?.start_at && appointment?.end_at
      ? startAt.getTime() <= now.getTime() && now.getTime() <= endAt.getTime()
      : false;
  const isInTheFuture = appointment?.start_at ? startAt.getTime() > now.getTime() : false;
  const wasInThePast = appointment?.end_at ? endAt.getTime() < now.getTime() : false;

  const isWarningModalEnabled =
    (isInTheFuture &&
      minutesBetween(now, startAt) >= MINUTES_TO_RECORD_DRUG_SCREEN_WITHOUT_MODAL) ||
    (wasInThePast && minutesBetween(endAt, now) >= MINUTES_TO_RECORD_DRUG_SCREEN_WITHOUT_MODAL);
  const isWithinTimeWindowToRecordDrugScreen =
    isOngoing ||
    (isInTheFuture && +daysBetween(now, startAt) <= DAYS_TO_RECORD_DRUG_SCREEN) ||
    (wasInThePast && +daysBetween(endAt, now) <= DAYS_TO_RECORD_DRUG_SCREEN);
  const isDrugScreenButtonEnabled =
    appointment?.drug_screen_expected && isWithinTimeWindowToRecordDrugScreen;
  const isDrugScreenButtonEnabledForAdHoc =
    !appointment?.drug_screen_expected &&
    isWithinTimeWindowToRecordDrugScreen &&
    appointment?.title &&
    SUPPORTED_APPOINTMENT_TYPES_FOR_AD_HOC_DRUG_SCREEN.includes(appointment.title);

  return {
    durationInMinutes,
    isDrugScreenButtonEnabled,
    isDrugScreenButtonEnabledForAdHoc,
    isInTheFuture,
    isOngoing,
    isWarningModalEnabled,
    startAt
  };
};
